import { Box, Typography } from '@mui/material'
import React, { useMemo } from 'react'

import useListLocationDetails from '../../dataFetchHooks/useListLocationDetails'
import { IQueryFilter } from '../../type'

interface InformationDisplayProps {
  startDate?: string
  queryFilter: IQueryFilter | null
}

const InformationDisplay: React.FC<InformationDisplayProps> = ({
  startDate = '',
  queryFilter,
}) => {
  // Fetch location details
  const { data: locationsMap } = useListLocationDetails()

  // Get the first location from queryFilter
  const selectedLocationId = queryFilter?.locationIds?.[0]
  const selectedLocation =
    selectedLocationId && locationsMap ? locationsMap[selectedLocationId] : null

  // Format date for display - handle timezone correctly
  const formatDate = (dateString: string) => {
    if (!dateString) return ''
    // Parse as UTC and format in local timezone to avoid date shifting
    const [year, month, day] = dateString.split('-').map(Number)
    const date = new Date(year, month - 1, day)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }

  const locationDisplay = useMemo(() => {
    if (!selectedLocation) return 'No location selected'
    return `${selectedLocation.code} - ${selectedLocation.name}`
  }, [selectedLocation])

  const dateDisplay = formatDate(startDate)

  return (
    <Typography
      variant="body1"
      sx={{
        fontFamily: 'Lexend-Regular',
        fontSize: '0.875rem',
      }}
    >
      Manual NBO data correction will be apply to the location{' '}
      <Box
        component="span"
        sx={{ fontFamily: 'Lexend-SemiBold', fontWeight: 600 }}
      >
        {locationDisplay}
      </Box>{' '}
      on{' '}
      <Box
        component="span"
        sx={{ fontFamily: 'Lexend-SemiBold', fontWeight: 600 }}
      >
        {dateDisplay}
      </Box>
    </Typography>
  )
}

export default InformationDisplay
